import React from 'react';
import PropTypes from 'prop-types';

import './Status.css';

const Status = (props) => {
  const { children } = props;
  switch (children) {
    case 'request_success':
    case 'SUCCESS':
      return <div className="Status success">Success</div>
    case 'Credit Check Completed':
      return <div className="Status success">Credit Check Completed</div>  
    case 'request_ctos_bad_request':
      return <div className="Status error">Bad Request</div>
    case 'request_ctos_failure':
      return <div className="Status error">CTOS Failure</div>
    case 'request_mhub_ctos_received':
      return <div className="Status orange">CTOS Received</div>  
    case 'await_multi_entity':
      return <div className="Status orange">Await Multiple Entities</div>  
    case 'request_ctos_muliple_entities':
      return <div className="Status orange">Multiple Entities</div>
    case 'new':
    case 'NEW':
      return <div className="Status new">New</div>
    case 'FAILED':
      return <div className="Status error">Failed</div>      
    default:
    return children;
  }
}

Status.propTypes = {
  children: PropTypes.node,
}

Status.defaultProps = {
  children: null,
}

export default Status;



// WEBPACK FOOTER //
// ./src/components/Status.jsx